import { jsx } from "react/jsx-runtime";
import { MediaObject } from "@zillow/constellation-10";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const ALIGN_MAP = {
  top: "flex-start",
  bottom: "flex-end",
  start: "flex-start",
  center: "center",
  end: "flex-end",
  stretch: "stretch"
};
const GUTTER_MAP = {
  xs: "tighter",
  sm: "default",
  md: "loose",
  lg: "looser",
  xl: "layout.looser"
};
const BlockMediaObject = ({
  attrs,
  index,
  innerBlocks
}) => {
  const mediaBlock = innerBlocks.find((block) => block.blockName === "constellation/media-object-media");
  const bodyBlock = innerBlocks.find((block) => block.blockName === "constellation/media-object-body");
  if (!mediaBlock || !bodyBlock) {
    console.warn("BlockMediaObject: missing media-object-media or media-object-body inner block");
  }
  const {
    reverse,
    align,
    direction,
    gutter,
    ...restAttrs
  } = attrs || {};
  const flexDirection = direction && direction !== "row" || reverse ? `${direction || "row"}${reverse ? "-reverse" : ""}` : void 0;
  const cssProps = {
    ...flexDirection && {
      flexDirection
    },
    // Always pass alignItems; default to 'stretch' when not set to preserve v8
    // behavior (v8 had no align-items rule = browser stretch; v10 base defaults to 'start')
    alignItems: align ? ALIGN_MAP[align] || align : "stretch",
    ...gutter && {
      gap: GUTTER_MAP[gutter] || gutter
    }
  };
  const cssSpread = {
    css: cssProps
  };
  return /* @__PURE__ */ jsx(MediaObject, { media: generateBlockList({
    blocks: (mediaBlock == null ? void 0 : mediaBlock.innerBlocks) ?? []
  }), ...restAttrs, ...cssSpread, children: generateBlockList({
    blocks: (bodyBlock == null ? void 0 : bodyBlock.innerBlocks) ?? []
  }) }, index);
};
export {
  BlockMediaObject as default
};
